import { createContext, useContext, useEffect, useState } from 'react';
import { fetchSheetData } from '../utils/googleSheetAPI';

const dataContext = createContext()
export function DataProvider({ children }) {

    const [sheetData, setSheetData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isError,setIsError] = useState(false)

    const load = () =>{
        setIsLoading(true)
        setIsError(false)
        fetchSheetData()
            .then((res) => {
                setIsLoading(false)
                setSheetData(res)
            })
            .catch((e) => {
                setIsLoading(false)
                setIsError(true)
                alert(e.message)
            })
    }
    const refresh = load 

    useEffect(() => {
        load()
    }, [])

    return (
        <dataContext.Provider value={{
            sheetData,
            isLoading,
            isError,
            refresh
        }}>
            {children}
        </dataContext.Provider>
    );
}
export const useData = () => useContext(dataContext);
